import { saberApi } from '../../saberApi'

// Injected upload endpoint for the Base Case Model import drawer.
// Backend: POST /api/v1/admin/base-case-model/upload
// (apps/common-public-service/src/modules/admin/BaseCaseModel/baseCaseModel.controller.ts).
// Multipart fields mirror BaseCaseModelUploadDTO exactly: `file`, `shouldPersist`,
// optional `nameResolutions` (JSON-encoded object).

export interface BaseCaseFuzzyMatchSuggestion {
  cuid: string
  name: string
  distance: number
}

export interface BaseCaseFuzzyMatch {
  rowNumber: number
  field: 'project' | 'property' | 'investor'
  inputValue: string
  suggestions: BaseCaseFuzzyMatchSuggestion[]
}

// Mirror of BaseCaseModelUploadResponseDTO.
export interface BaseCaseUploadResponse {
  success: boolean
  recordsProcessed: number
  recordsCreated: number
  recordsSkipped: number
  duplicates: string[]
  errors?: string[]
  fuzzyMatches?: BaseCaseFuzzyMatch[]
}

export interface BaseCaseUploadArgs {
  file: File
  shouldPersist: boolean
  /** e.g. { "row5_project": "abc123" } — resolves fuzzy-matched names to cuids. */
  nameResolutions?: Record<string, string>
}

export const baseCaseUploadApi = saberApi.injectEndpoints({
  endpoints: (builder) => ({
    uploadBaseCaseModel: builder.mutation<BaseCaseUploadResponse, BaseCaseUploadArgs>({
      query: ({ file, shouldPersist, nameResolutions }) => {
        const form = new FormData()
        form.append('file', file)
        form.append('shouldPersist', String(shouldPersist))
        if (nameResolutions != null) {
          form.append('nameResolutions', JSON.stringify(nameResolutions))
        }
        return { method: 'POST', url: '/base-case-model/upload', data: form }
      },
      // CSV rows can target multiple properties — invalidate every cached getBaseCase.
      invalidatesTags: (result) =>
        result?.success === true && (result.recordsCreated ?? 0) > 0 ? [{ type: 'BaseCase' }] : []
    })
  })
})

export const { useUploadBaseCaseModelMutation } = baseCaseUploadApi
